/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ROLES } from '../../../constants';
import { getRole } from '../../../utils/roleUtils';
import { useGetTriadInfoQuery } from './triad.slice';
import { selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';

interface TriadExpandedGridProps {
    selectedEmployee: string;
    inputYear: number;
    inputMonth: number;
    isPseudoSupervisor: boolean;
    userManagerLevel: string;
    loggedEmpNo: string;
    handleGridButtonClick: (columnName: string, grid:string, rowData?: any, mode?:any) => void;
    handlefollowupClick: (rowData: any) => void;
    // setChildGridData: (data: any) => void;
}

export const TriadExpandedGrid = (props: TriadExpandedGridProps) => {
    const [expandedRows, setExpandedRows] = useState<any>();
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    const { data: coachingSummaryGrid } = useGetTriadInfoQuery(
        {
            loggedempNumber: props.loggedEmpNo,
            employeeNumber: props.selectedEmployee,
            year: props.inputYear,
            month: props.inputMonth,
            teamOption: 'expand',
            role: getRole(props.userManagerLevel, props.isPseudoSupervisor),
        },
        {
            skip: !props.selectedEmployee || !props.inputYear || !props.inputMonth,
        }
    );

    useEffect(() => {
        if (coachingSummaryGrid?.data?.length > 0) {
            setExpandedRows(coachingSummaryGrid.data);
            // props.setChildGridData(coachingSummaryGrid.data);
        }
    }, [coachingSummaryGrid]);

    const scoreRender = (rowData: any) => {
        return <div style={{ textAlign: 'center' }}>{rowData?.avg_asse_score?.length > 0 ?  (rowData?.avg_asse_score * 100).toFixed(2) + '%' : '--'}</div>;
    };

    const renderCountValues = (rowData: any) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <div style={{ marginLeft: '25px' }}>
                    {rowData?.acknowledged_count}/{rowData?.total_triads_completed}
                </div>
            </div>
        );
    };
    
    const renderIcons = (rowData: any, columnName: string) => {
        const { userManagerLevel } = props;
        const hasData = !!rowData[columnName];
        if (ROLES.DirectorOrAbove.includes(userManagerLevel) || ROLES.Supervisor2AndManagers.includes(userManagerLevel)) {
            return hasData? 'pi pi-pencil' : 'pi pi-plus';
        }    
        if (ROLES.Supervisor.includes(userManagerLevel) && hasData) {
            return 'pi pi-pencil';
        }
    
        return false;
    };
    const followUpRender = (rowData: any) => {
        if (ROLES.Supervisor.includes(rowData?.manager_level) && ((!ROLES.Supervisor.includes(userManagerLevel)) || rowData?.follow_up_discussions_count > 0)) {
            return (
                <div style={{ textAlign: 'center' }}>
                    {rowData?.follow_up_discussions_count > 0 ? (
                        <div style={{ textAlign: 'center', display: 'flex', marginLeft: '30px' }}>
                            <div style={{
                                border: '1px solid #00D6BB',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <span>{rowData?.follow_up_discussions_count}</span>
                                <div style={{
                                    height: '20px',
                                    width: '1px',
                                    backgroundColor: '#00D6BB',
                                    margin: '0 10px',
                                }} />
                                <i
                                    className="pi pi-eye"
                                    style={{ cursor: 'pointer', color: '#00D6BB', }}
                                    onClick={() => props.handlefollowupClick(rowData)}
                                />
                            </div>
                        </div>
                    ) : (
                        <Button
                            type="button"
                            icon={'pi pi-plus'}
                            style={{
                                background: 'transparent',
                                border: '#00D6BB 1px solid',
                                color: '#00D6BB',
                                width: '30px',
                                height: '30px',
                            }}
                            onClick={() => {
                                props.handlefollowupClick(rowData);
                            }}
                        />
                    )}
                </div>
            );
        }
        else {
            return <div style={{ textAlign: 'center',paddingLeft:'15px'}}>--</div>;
        }
    }
    const buttonTemplate = (rowData: any, columnName: string, colorCode: any) => {
        const color = colorCode;
        const icon = renderIcons(rowData, 'total_created_count');
        const mode = icon === 'pi pi-plus' ? 'new' : 'edit';
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Button
                        type="button"
                        icon={icon}
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                            marginRight: '22px',
                        }}
                        //disabled = {rowData?.total_created_count <= 0 && ROLES.DirectorOrAbove.includes(props?.userManagerLevel)}
                        onClick={()=>{props?.handleGridButtonClick(columnName, 'child', rowData,mode)}}
                    />
                </div>
            </div>
        );
    };
    return (
        <DataTable
            value={expandedRows}
            id="revgen-subgrid"
            rows={5}
            paginator={expandedRows?.length > 5}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[5, 10, 25, 50]}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            emptyMessage="No records found."
            showGridlines={false}
            stripedRows
        >
            <Column field="employee_name" style={{ width: '9.8rem' }} />
            <Column
                field="goals_created"
                style={{ width: '5rem' }}
                body={(rowData: any) => buttonTemplate(rowData, 'triads', '#00D6BB')}
            />
            <Column
                field="supervisor_discussed"
                style={{ width: '7rem' }}
                body={(rowData: any) => renderCountValues(rowData)}
            />
            <Column field="triads" style={{ width: '7rem' }} body={(rowData: any) =>scoreRender(rowData)} />
            <Column  field="triads" style={{ width: '5rem' }} body={(rowData: any) => followUpRender(rowData)}/>
            <Column style={{ width: '1rem' }} />
            <Column style={{ width: '5rem' }} />
        </DataTable>
    );
};
